// CryptoManager.js
import CryptoJS from 'crypto-js';

const key = CryptoJS.enc.Utf8.parse('@S4h!wY9k#D7&fP2'); // 16 bytes key

export const CryptoManager = {
  encryptString: (plainText) => {
    const iv = CryptoJS.lib.WordArray.random(16); // AES block size is 16 bytes

    const encrypted = CryptoJS.AES.encrypt(plainText, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    // Combine IV + encrypted ciphertext (like C# code)
    const combined = iv.concat(encrypted.ciphertext);

    return CryptoJS.enc.Base64.stringify(combined); // Return as Base64 string
  },

  decryptString: (cipherTextBase64) => {
    const combined = CryptoJS.enc.Base64.parse(cipherTextBase64);

    const iv = CryptoJS.lib.WordArray.create(combined.words.slice(0, 4)); // 4 words = 16 bytes
    const ciphertext = CryptoJS.lib.WordArray.create(combined.words.slice(4));

    const decrypted = CryptoJS.AES.decrypt(
      { ciphertext: ciphertext },
      key,
      {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );

    return decrypted.toString(CryptoJS.enc.Utf8);
  },
};
